import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import CampaignDevices from './CampaignDevices';

interface DeviceslogsTabsProps {
    stageId?: number;
    campaignId?: number;
}

const DevicesLogsTabs: React.FC<DeviceslogsTabsProps> = (props) => {
    const [activeTab, setActiveTab] = useState('devices');

    const handleTabChange = (tabId: string) => () => {
        setActiveTab(tabId);
    };
    return (
        <div className='margin-top-20'>
            <ul className='nav nav-pills '>
                <li className={activeTab === 'devices' ? 'active' : ''}>
                    <a onClick={handleTabChange('devices')}>
                        <FormattedMessage id='intl-msg:devices' defaultMessage='Devices'/>
                    </a>
                </li>
                <li className={activeTab === 'logs' ? 'active' : ''}>
                    <a className={'disabled'} onClick={handleTabChange('logs')}>
                        <FormattedMessage id='intl-msg:logs' defaultMessage='Logs'/>
                    </a>
                </li>
            </ul>

            <div className='padding-20'>
                {activeTab === 'devices' && (
                    <CampaignDevices {...props}/>
                )}
                {activeTab === 'logs' && (
                    <div>
                        {/* Logs content will go here */}
                        <p><FormattedMessage id='intl-msg:logs:content' defaultMessage='Logs content'/></p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DevicesLogsTabs;
